import React from "react";

function Header() {
  return (
    <header>
      <h1>
        Note Keeper...
        <span role="img" aria-label="emoji">
          🧠
        </span>
      </h1>
    </header>
  );
}

export default Header;
